var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'v2': !_vm.v1, 'v1': _vm.v1 }},[_c('button',_vm._g({staticClass:"ssa-button",class:{
                'button-linkStyle': _vm.link,
                'primary headlineSmall': !_vm.link,
                large: _vm.large
            },attrs:{"type":_vm.type,"id":_vm.id,"disabled":_vm.loading}},_vm.$listeners),[(!_vm.loading)?_c('span',[_vm._t("default")],2):_vm._e(),(_vm.loading)?_c('IconBase',{staticClass:"loader-icon",attrs:{"width":"30","height":"16","display":"inline-flex","iconName":"loaderIcon"}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }